import "./App.css";

import { useState } from "react";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";
import Skills from "./components/Skills";
import  Fotter  from "./components/Fotter";
import Contact from "./components/Contact";
import Projects from "./components/Projects";
import Headeer from "./components/Header1";
import Navbar1 from "./components/Navbar1"
function App() {
  const [mode, setMode] =useState(true);
  return (
    <div className=" overflow-x-hidden ">
      <Navbar1 mode={mode} setMode={setMode} />
      <Navbar mode={mode} setMode={setMode} />
      <Home mode={mode} setMode={setMode} />
      <About />
      <Skills />
      <Projects />
      <Contact mode={mode} />
      <Headeer />
      <Fotter mode={mode} />
      <Headeer />
    </div>
  );
}

export default App;
